module.exports = __webpack_public_path__ + "static/img/71.55a42691.gif";